module.exports = __webpack_public_path__ + "img/Rod_1Tip.79e74bd0.png";